module.exports = __webpack_public_path__ + "img/overbooking-big.f2aeaf3d.svg";